'use es6';

export var LAPTOPHEIGHT = '900px';
export var TABLETWIDTH = '768px';
export var DESKTOPMAXWIDTH = '1160px';